import React, { useEffect, useState } from 'react'
import moment from 'moment'
import axios from 'axios'
import api from '../components/api'
// import { useTabelaGestao } from '../context/GestaoPendenciasContext'

const PlanilhaEnergia = (props) => {

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id

    var linkAPI = 'http://172.16.1.253:3600/'
    //var linkAPI = 'http://apihomolog.hospitaissaudaveis.org/'

    

    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    var [energia_id, setEnergia_id] = useState()
    var [statusProcessamentoArquivo, setStatusProcessamentoArquivo] = useState('Não enviado')
    var [nomeArquivo, setNomeArquivo] = useState()
    var [file, setFile] = useState()



    async function carregaDados() {

        //console.log(ano, '!?')

        if (!isNaN(ano)) {

            //console.log(ano)

            await api.get(`energiaPlanilha/${adesao_institucional_id}/${ano}`).then((result) => {

                console.log(result.data)
                
                var data = result.data[0]
    
                if (data) {
    
    
                    var statusProcessamentoArquivoTemp = data.statusProcessamentoArquivo
    
                    switch (statusProcessamentoArquivoTemp) {
    
                        case 'P':
                            var statusProcessamentoArquivoTemp_descri = 'Pendente'
                            break
    
                        case 'V':
                            var statusProcessamentoArquivoTemp_descri = 'Validado'
                            break
    
                    }
    
                    setEnergia_id(data.energia_id)
                    setNomeArquivo(data.arquivo)
                    setStatusProcessamentoArquivo(statusProcessamentoArquivoTemp_descri)
    
    
                }
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        


    }



    function enviaPlanilha() {

        if (file == '') {

            window.toastr.error('Arquivo inválido!')
            return false

        } else {

            //var file_array = file.split('.')


        }


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'blue',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    

                    const formData = new FormData();
                    const imagefile = document.querySelector("#planilhaDesafioEnergia");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("planilha", imagefile.files[0]);
                    //formData.append("tipoInventario", tipoInventario); // string junto ao formData.
                    
                    //console.log('altera')
                    //return false

                    axios.post(`${linkAPI}energiaPlanilha/${energia_id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': '!nf0$@ud#2',
                    }
                    }).then(response => {

                        console.log(response.data)
                        //setImagem(response.data.imagem)
                        //setFile('')

                        if (response.data.alerta == 'ok') {

                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            setNomeArquivo(response.data.arquivoImportado)
                            setStatusProcessamentoArquivo('Pendente')
                            setFile('')

                            window.$.confirm({
                                //icon: 'fa fa-question',
                                theme: 'material',
                                closeIcon: true,
                                animation: 'scale',
                                type: 'green',
                                title: 'Obrigado!',
                                content: 'Aguarde o processamento da planilha!',
                                buttons: {
                                    Ok: function () {
    
                                    }
                    
                                },
                    
                            });
    

                        } else {


                            window.toastr.error('Ocorreu um erro, por favor tente mais tarde!')
                            return false
                            
                        }


                        


                    }).catch((err) => {

                        console.log(err.response)

                    })


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    function downloadPlanilha() {


        if (nomeArquivo) {


            window.location.href = `https://cdn.hospitaissaudaveis.org/uploads/desafioEnergia/${nomeArquivo}`


        }



    }


    useEffect(() => {

        setEnergia_id('')
        setNomeArquivo('')
        setStatusProcessamentoArquivo('Não enviado')

        carregaDados()

    }, [ano, adesao_institucional_id])



    return (


        <div>

            <div style={{ display: energia_id ? 'none' : 'block'}} >

            Por favor, preencha os Dados de consumo de energia e equipamentos primeiro!

            </div>


            
            <div style={{ display: energia_id ? 'block' : 'none'}} >


                <div className="row">


                    <div className="col-md-9">
                        <div class="form-group" >
                            <label className="control-label">Planilha atual:</label>
                            <input type="text" className="form-control" value={nomeArquivo} readOnly style={{ cursor: nomeArquivo ? 'pointer' : 'auto'}} onClick={() => downloadPlanilha()}/>
                                

                        </div>
                    </div>

                    <div className="col-md-3">
                        <div class="form-group" >
                            <label className="control-label">Status:</label>
                            <input type="text" className="form-control" id="statusPlanilha" value={statusProcessamentoArquivo} disabled />
                                

                        </div>
                    </div>

                    
                        <div class="form-group" style={{ display: 'none'}}>
                            <label className="control-label">Fazer o upload da PLANILHA:</label>
                            <input type="file" className="form-control" id="planilhaDesafioEnergia" value={file} onChange={event => setFile(event.target.value)} />
                                

                        </div>
                    </div>

                    <div className="col-md-12">

                        <div align="right">

                            <button type="button" className="btn btn-info">Processar planilha</button>

                        </div>

                    </div>
                  




            </div>


            

        </div>

    )

}

export default PlanilhaEnergia